<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <search-filter-new
          :items="topMenu"
          :hasFilter="hasFilter"
          :campus="params.campusList"
          placeholder="请输入课程名称"
          @onSearch="params.curriculumName = $event"
          @onCampus="chooseCampus"
          @onFilter="openFilter"
        >
        </search-filter-new>
      </div>

      <vx-list class="smain" enable :api="api" :params="params" @load="onLoad" ref="vxlist">
        <div class="slist">
          <div
            class="sitem van-hairline--bottom"
            v-for="item in listAll"
            :key="item.id"
            @click="clickHandler(item)"
          >
            <div class="l sicon">
              <side-icon-select :checked="ids.includes(item.id)" />
            </div>
            <div class="r van-ellipsis" :class="{ disable: item.haltSale }">
              <div class="name van-ellipsis">{{ item.curriculumName }}</div>
              <div class="attr van-ellipsis">{{ item.dimensionNameText }}</div>
              <div class="tags">
                <div class="left">
                  <van-tag
                    plain
                    type="primary"
                    class="ttag"
                    v-for="itm2 in item.priceItemVoList"
                    :key="itm2.id"
                    >{{ itm2.chargeType == 2 ? '按天' : `按${lessonUnit}` }}</van-tag
                  >
                </div>
                <div class="right" >
                  <div class="more" v-if="(config.isCard || config.showSuspend) && item.suspendDate">{{ item.suspendDate | formatDatetime('yyyy-MM-dd') }} 暂停计费</div>
                  <!-- 当是根据学员查课程时(接口：cs-edu/curriculum/findCurriculumInfoByStudentId)，会有是否‘不再上课的属性’ -->
                  <van-tag plain type="primary" color="var(--g5)" v-if="item.courseRelation === 0">不再上课</van-tag>
                  <van-tag color="var(--g5)" v-if="item.haltSale">已停售</van-tag>
                  
                </div>
              </div>
            </div>

            <!-- 当是根据学员查课程时(接口：cs-edu/curriculum/findCurriculumInfoByStudentId)，会有是否‘不再上课的属性’ -->
            <!-- <svg class="vxm-icon buzaiicon" aria-hidden="true" v-if="item.courseRelation === 0">
              <use xlink:href="#vxm-icon-buzaishangke"></use>
            </svg> -->
          </div>
        </div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="未找到课程~"
          image-size="128"
          style="margin-top: 20vh"
        ></van-empty>
      </vx-list>

      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          :isAll="checkAll"
          key_txt="curriculumName"
          @clickAllBtn="checkAll = !checkAll"
        />
      </side-foot>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-course-new',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '选择课程',
      // 是否正在加载数据
      loading: true,

      api: this.$api.curriculumPageList,
      params: {
        // 搜索词
        curriculumName: '',
        campusIds: [],
        campusList: [],
        chargeTypeList: [],
        haltSaleList: [],
        dimensionDetailIdList: [],
      },
      // 配置项
      config: {
        // 是否单选功能
        radio: false,
        // 是否必须至少选择一项
        must: false,
        enableFilter: true,
        // 是否是课程卡的接口
        isCard: false,
        showSuspend: false,
      },
      filter: {
        // 校区筛选是否开启
        enableCampusFilter: false,
        // 计费方式筛选是否开启
        enableChargeType: true,
        // 启停售筛选是否开启
        enableHaltSale: true,
        // 课程属性筛选
        enableDimension: true,
      },
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    topMenu() {
      let list = [],
        fit = this.filter;
      if (fit.enableCampusFilter) {
        list.push('campus');
      }
      list.push('search');
      if (this.config.enableFilter) {
        list.push('filter');
      }
      return list;
    },
    // 当前是否有筛选
    hasFilter: function () {
      let flt = this.filter,
        pms = this.params;
      if (flt.enableCampusFilter && pms.campusIds.length > 0) {
        return true;
      } else if (flt.enableChargeType && pms.chargeTypeList.length > 0) {
        return true;
      } else if (flt.enableHaltSale && pms.haltSaleList.length > 0) {
        return true;
      } else if (flt.enableDimension && pms.dimensionDetailIdList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    // 数据加载
    onLoad(list, res) {
      this.listAll = list;
      this.total = res.page.totalCount;
      this.loading = false;
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    async openFilter() {
      let res = await app.x3.side.xsCourseFiltrate({
        params: this.params,
        dimensionList: this.dimensionList,
        config: this.filter,
      });
      Object.assign(this.params, res.params);
      this.dimensionList = res.dimensionList;
    },
    getItem(itm) {
      return {
        ...itm,
        curriculumId: itm.id,
      };
    },
  },
  created() {
    if (this.config.isCard) {
      this.api = this.$api.cardPageList;
    }
    if (this.config.showSuspend) {
      this.params.type = 5;
    }
    this.$onBus('courseListRefresh', () => {
      this.$refs.vxlist && this.$refs.vxlist.refresh();
    });
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        position: relative;
        display: flex;
        padding: calc(var(--gap) * 12) 0;
        .l.sicon {
          margin-right: calc(var(--gap) * 16);
          padding-top: calc(var(--gap) * 2);
        }
        .r {
          flex: 1;
          &.disable {
            .left {
              .name,
              .attr {
                opacity: 0.6;
              }
            }
          }
          .name {
            font-size: var(--fs-md);
            line-height: var(--lh-md);
            color: var(--g8);
          }
          .attr {
            padding-top: calc(var(--gap) * 4);
            font-size: var(--fs-sm);
            line-height: var(--lh-sm);
            color: var(--g6);
          }
          .tags {
            display: flex;
            margin-top: calc(var(--gap) * 4);
            .left {
              flex: 1;
              .ttag + .ttag {
                margin-left: 8px;
              }
            }
            .right {
              display: flex;
              .van-tag {
                margin-left: calc(var(--gap) * 4);
              }
              .more {
                color: var(--c4);
                margin-right: calc(var(--gap) * 12);
              }
            }
          }
        }
        // .buzaiicon {
        //   font-size: 44px;
        //   color: var(--g5);
        //   position: absolute;
        //   right: 5px;
        //   bottom: 5px;
        //   transform: rotate(30deg);
        // }
      }
    }
  }
}
</style>